/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { elementHasClassName, htmlspecialchars } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getFromSession } from './session-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { createSearchRequest } from './search-request.js';
import { MDMeta } from './meta-data.js';
import { MDTrees } from './tree-data.js';

import { scrollElementIntoView } from './dialog-util.js';

import { register_ref_media_meta_field_plugin } from './media-data-ref-type-plugin.js';
import { register_std_plugins } from './media-data-std-plugins.js';

import './media-result-view-widget.js';


export let MVSelectMediaItems = function($,mj) {

	var m_dlg_id = 'smi-form';
	var m_dlg = null;
	var m_dlg_w = 500;
	var m_dlg_h = 400;

	var m_root_element = null;

	const initial_result = {
		result_list_id:		0,		// = list with results of search + color filter + options (before category filter)
		work_list_id:		0,		// = list with results after category filter
		text_result_count:	0,		// = count of results of text search (before color, metadata & category filters)
		result_count:		0,		// = count of results in result_list_id (before category filter)
		work_count:			0,		// = count of results in work_list_id (after category filter)
	};

	let m_cur_result = Object.assign( {}, initial_result );

	function _compute_dlg_dimensions() {
		var win = $(window);
		m_dlg_w = Math.min( Math.max( win.width()-16,730), 2130 );
		m_dlg_h = Math.min( Math.max(win.height()-20,290), 4000 );
	}

	function _destroy_dlg() {
		if( m_root_element ) {
			m_root_element.empty();
		} else {
			$(document).off('mjswinresize.MVSelectMediaItems');
			if( m_dlg ) {
				$('#'+m_dlg_id+'-trees').remove();
				m_dlg.remove();
				m_dlg.dialog('destroy');
				m_dlg = null;
			}
		}
	}
	function _setup_dlg() {
		_destroy_dlg();
		var html =  '<div id="'+m_dlg_id+'" style="display:none" title="'+mjt('wdg-smi-single-title')+'">';
		html += '<div id="'+m_dlg_id+'-left">';
		html += 	'<div id="'+m_dlg_id+'-search">';
		html += 		'<div id="'+m_dlg_id+'-trees"></div>';
		html += 	'</div>';
		html += '</div>';
		html += '<div id="'+m_dlg_id+'-right"><div id="'+m_dlg_id+'-result-info" class="media-result-info-view"></div><div id="'+m_dlg_id+'-result" class="media-result-view"></div></div>';
		html += '</div>';

		if( m_root_element ) {
			// append to element
			m_root_element.html(html);
			m_dlg = $('#'+m_dlg_id,m_root_element);
		} else {
			// show as dialog
			$('#progress').after(html);
			m_dlg = $('#'+m_dlg_id);
			_compute_dlg_dimensions();
			m_dlg.dialog( { width:m_dlg_w, height:m_dlg_h, modal:true, resizable:false, close:function(ev,ui) {
				_destroy_dlg();
			} } );
			$(document)
				.on('mjswinresize.MVSelectMediaItems', $.debounce( 250, function(evt,w,h) {
					_compute_dlg_dimensions();
					if( m_dlg ) m_dlg.dialog('option',{'width':m_dlg_w,'height':m_dlg_h});
				} ) );
		}
	}

	function _setup_tree( tree_id ) {
		var tnode = mj.trees[tree_id];
		if( tnode.visible && !tnode.metasearch_mode ) {
			$('#'+m_dlg_id+'-trees').append(
				'<div class="tree-title">'+htmlspecialchars(tnode.name)+'</div><div id="'+m_dlg_id+'-cat-tree-'+tree_id+'" class="cat-tree"></div>'
			);
			$('#'+m_dlg_id+'-cat-tree-'+tree_id).dynatree( {
				children: MDTrees.getDynatreeObjectFromTree(tree_id,true,true),
				persist: true,
				cookieId: 'mj-cdt-smi-'+tree_id,
				cookieOpts: mj.cookieopts,
				idPrefix: 'smi-cat-node-'+tree_id+'-',
				multiSelect: false,
				autoSelectChildren: false,
				nodeHREF: mj.uwn+'/media#category=%key%',
				onSelect: function( dtnode ) {
					_browse_category( tree_id, dtnode.data.key, false, false );
				},
			} );
		}
	}
	function _setup_trees() {
		for( var i=0; i<mj.trees_order.length; ++i ) {
			var tree_id=mj.trees_order[i];
			_setup_tree(tree_id);
		}
	}

	function _set_category_browse_result( tree_id, cat_id, resetResultLists ) {
		function upd_result( j ) {
			// remember result info
			m_cur_result.result_count = j.result_count;
			m_cur_result.work_count = j.work_count;
			m_cur_result.result_list_id = j.result_list_id;
			m_cur_result.work_list_id = j.work_list_id;
			// update result view
			var result_elem = $('#'+m_dlg_id+'-result');
			// WARNING: dont use .mjMediaResultViewWidget('instance') - it would trigger memory leaks!!
			var result_widget = result_elem.data('mj-mjMediaResultViewWidget');	//result_elem.mjMediaResultViewWidget('instance')
			result_widget.loadSearchResult( m_cur_result.work_list_id, tree_id, cat_id, m_cur_result.work_count );
		}
		var postdata = '';
		if( cat_id===0 ) postdata = 'in_categories=&in_trees='+tree_id+'&not_in_trees='+tree_id;
		else postdata = 'in_categories='+cat_id+'&in_trees='+tree_id;
		var post_url = 'json/media/search';
		startProgress();
		if( resetResultLists ) {
			Object.assign( m_cur_result, initial_result );
		}
		if( m_cur_result.result_list_id==0 ) {
			// initial search
			postdata += '&search[string]='+encodeURIComponent('*');
		} else {
			// filtered search
			post_url = 'json/media/search-filter';
			postdata += '&result_list_id='+m_cur_result.result_list_id+'&work_list_id='+m_cur_result.work_list_id;
		}
		$.postJSON( post_url, postdata, function(j) {
			stopProgress();
			if( j ) upd_result(j);
		}, true );
	}

	function _browse_category( tree_id, cat_id, scrollIntoView, resetResultLists ) {
		if( tree_id===null ) {
			tree_id = cat_id===0 ? 1 : MDTrees.getTreeIdFromCategoryId(cat_id);
			if( tree_id===null ) return;
		}
		var dt = $('#'+m_dlg_id+'-cat-tree-'+tree_id);
		if( dt && dt.length ) {
			dt = dt.dynatree('getTree');
			if( dt && ('getNodeByKey' in dt) ) {
				var n = dt.getNodeByKey(cat_id);
				if( n ) {
					// make this node visible
					n.makeVisible();
					// expand it (to show child categories)
					n._expand(true);
					// collapse all siblings (this avoids that the "whole tree" is expanded after some browsing through it)
					n.collapseSiblings();
					// unselect all other categories in other trees
					for( var other_tree_id in mj.trees ) {
						if( !mj.trees.hasOwnProperty(other_tree_id) ) continue;
						if( other_tree_id!=tree_id ) {
							var tnode = $('#'+m_dlg_id+'-cat-tree-'+other_tree_id);
							if( tnode.length ) tnode.dynatree('getTree').unselectAllNodes();
						}
					}
					// actually select the one
					n.select(null,false,true);
					if( scrollIntoView ) {
						scrollElementIntoView( $(n.div), $('#'+m_dlg_id+'-search'), 10, 3, 10 );
					}
					// update result view
					_set_category_browse_result(tree_id,cat_id,resetResultLists);
				}
			}
		}
	}


	function selectSingleItem( options ) {

		m_root_element = null;
		let callback = null;
		if( typeof options === 'function' ) {
			callback = options;
		} else {
			callback = options.callback ?? null;
			m_root_element = options.element ?? null;
		}

		const resetResultLists = options.resetResultLists ?? false;

		var cfg_view_type_fixed = 'table';	// => always use table view
		//var cfg_view_type_fixed = null;	// => use 'view_type' setting from users session

		var mrv_widget_options = {
			dyn_id_pfx: 'st',
			max_items_per_page: 100,
			buttons: [ ],
			list_changed: function( evt, list_data_obj ) {
				const search_info_obj = createSearchRequest({is_category_browsing:true});
				$('#'+m_dlg_id+'-result-info').mjMediaResultInfoWidget('updateResultInfo',list_data_obj,search_info_obj);
			},
			get_view_size: function() {
				return '9';
			},
			set_view_size: function( size ) {
			},
		};
		if( cfg_view_type_fixed!==null ) {
			mrv_widget_options.get_view_type = function() {
				return cfg_view_type_fixed;
			};
			mrv_widget_options.set_view_type = function(type) { };
		}

		_setup_dlg();
		_setup_trees();

		$('#'+m_dlg_id+'-result-info').mjMediaResultInfoWidget();
		var result_elem = $('#'+m_dlg_id+'-result');
		result_elem.mjMediaResultViewWidget(mrv_widget_options);

		result_elem
			// click on media thumbnail
			.on( 'click', '.thumbnail,.media_id',
				function( evt ) {
					var m = $(this).closest('.media','#'+m_dlg_id+'-result-info');
					if( !elementHasClassName(m[0],'deleted') ) {
						var selected_id = m.data('media_id');
						if( !m_root_element ) {
							_destroy_dlg();
						}
						callback(selected_id);
					}
					return false;
				} )
			// click on category thumbnail
			.on( 'click', '.cthumbnail,.category_title1',
				function( evt ) {
					var c = $(this).closest('.category','#'+m_dlg_id+'-result-info');
					var cat_id = c.attr('mj_cat_id');
					_browse_category(null,cat_id,false);
					return false;
				} );

		m_dlg.show();

		// WARNING: dont use .mjMediaResultViewWidget('instance') - it would trigger memory leaks!!
		var resultWidget = result_elem.data('mj-mjMediaResultViewWidget');
		//var result_widget = result_elem.mjMediaResultViewWidget('instance');
		if( resultWidget ) resultWidget.setViewType( cfg_view_type_fixed===null ? getFromSession('view_type') : cfg_view_type_fixed, false );


		const browseCategoryId = options.browseCategoryId ?? null;
		if( browseCategoryId ) {

			// browse to the specified category
			_browse_category(null,browseCategoryId,true,resetResultLists);

		} else {

			// browse to the first category of first visible tree:
			for( var i=0; i<mj.trees_order.length; ++i ) {
				var tree_id=mj.trees_order[i], tnode=mj.trees[tree_id];
				if( tnode.visible ) {
					if( tnode.nodes_order && tnode.nodes_order.length ) {
						_browse_category( tree_id, tnode.nodes_order[0], true, resetResultLists );
						break;
					}
				}
			}
		}
	}

	function loadAuxData( ondone ) {
		MDTrees.ensureTreeDataLoaded( function _ondone1() {
			if( mj.hasOwnProperty('result') ) {
				if( ondone ) ondone();
			} else {
				$.postJSON( 'json/widgets/config-result_view', '', function(j) {
					if( j ) {
						mj.result = j.result;
						MDMeta.init(j.result_view_meta_defs,register_std_plugins,register_ref_media_meta_field_plugin);
						if( ondone ) ondone();
					}
				}, true );
			}
		} );
	}

	return {
		selectSingleItem: function( options ) {
			loadAuxData( function() {
				selectSingleItem(options);
			} );
		},
	};

}(jQuery,mj); // namespace MVSelectMediaItems

